import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `// Integer types implement basic comparison and arithmetic operators.
// Felt252 operations should be avoided where possible, as they could have unwanted behavior.

use debug::PrintTrait;
${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `// TODO: return the solution of x^3 + y - 2

fn poly(x: usize, y: usize) -> usize {
    let res = // FILL ME
    res
}`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
#[test]
fn test_poly() {
    let res = poly(5_usize, 3_usize);
    assert(res == 126_usize, 'Error message');
    assert(res < 300_usize, 'res < 300');
    assert(res <= 300_usize, 'res <= 300');
    assert(res > 20_usize, 'res > 20');
    assert(res >= 2_usize, 'res >= 2');
    assert(res != 27_usize, 'res != 27');
}`;
